import OneTemplate from './one-template';

export { default as OneTemplateContent } from './one-template-content';
export { default as OneTemplateSummary } from './one-template-summary';
export { default as OneTemplateFooter } from './one-template-footer';
export default OneTemplate;
